import { boot } from 'quasar/wrappers'
import axios from 'axios'
import { Notify, Platform } from 'quasar'
import { isSubscriptionBlocked } from 'src/logic/subscription'

export const nsApi = axios.create({ baseURL: process.env.NS_DOMAIN })
export const api = axios.create({ withCredentials: true, withXSRFToken: true })

export async function getBaseUrlFromPiva(piva: string) {
  const { data } = await nsApi.post('/', { piva, app: process.env.URI })
  return data
}

export default boot(async ({ store, router }) => {
  await store.dispatch('tenant/init')

  api.interceptors.request.use(
    config => {
      if (Platform.is.capacitor) {
        const { piva } = store.state.tenant
        if (piva) config.headers.piva = piva

        const { token } = store.state.auth
        if (token) config.headers.Authorization = `Bearer ${token}`
      }
      config.baseURL = store.getters['tenant/url']
      return config
    },
    error => Promise.reject(error),
  )

  // stato del canone: header presenti solo in tolleranza, assenti con stato attivo
  const readSubscriptionHeaders = ({ headers }: { headers: Record<string, any> }) => store.commit('subscription/setStatus', {
    status: headers['x-subscription-status'],
    validUntil: headers['x-subscription-valid-until'],
  })

  api.interceptors.response.use(response => {
    readSubscriptionHeaders(response)
    return response
  }, error => {
    if (isSubscriptionBlocked(error)) {
      store.commit('subscription/setBlocked', {
        message: error.response.data.message,
        hasSession: !['login', 'token'].includes(error.config.url),
      })
      // prima della navigazione iniziale ci pensa la guard in boot/auth
      const { matched, path } = router.currentRoute.value
      matched.length > 0 && path !== '/402' && router.push('/402').catch(() => {})
      return Promise.reject(error)
    }

    if (error.response) {
      readSubscriptionHeaders(error.response)

      if (![422, 404].includes(error.response.status) && store.state.apis.finish) {
        if (process.env.PROD) {
          Notify.create({
            message: error.response.data.message ? 'Attenzione' : 'Operazione non riuscita',
            caption: error.response.data.message || 'Abbiamo riscontrato un problema con il server',
            type: 'negative',
          })
        } else {
          Notify.create({
            type: 'negative',
            message: JSON.stringify(error.message),
            caption: error.response.data.message,
            closeBtn: true,
            timeout: 0,
          })
        }
      }
    } else if (error.name !== 'InvalidTenant') Notify.create({ type: 'negative', message: 'Server non raggiungibile' })
    return Promise.reject(error)
  })
})
